module.exports = __webpack_public_path__ + "static/media/76.3510acf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/76.jpg
// module id = 634
// module chunks = 0